import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { trpc } from "@/lib/trpc";
import { formatarData, diaDaSemana } from "@/lib/utils";

export function Solicitacoes() {
  const listaQ = trpc.solicitacoes.listar.useQuery({ status: "pendente" });
  const utils = trpc.useUtils();
  const aprovar = trpc.solicitacoes.aprovar.useMutation({
    onSuccess: () => utils.solicitacoes.listar.invalidate(),
  });
  const rejeitar = trpc.solicitacoes.rejeitar.useMutation({
    onSuccess: () => utils.solicitacoes.listar.invalidate(),
  });

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-slate-900">Solicitações pendentes</h1>
      {!listaQ.data?.length && !listaQ.isLoading && (
        <Card>
          <CardContent className="p-8 text-center text-slate-500">
            Nenhuma solicitação pendente.
          </CardContent>
        </Card>
      )}
      {(listaQ.data ?? []).map((s) => (
        <Card key={s.id}>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Badge variant={s.tipo === "criacao" ? "ativo" : "inativo"}>
                {s.tipo === "criacao" ? "Criação" : "Exclusão"}
              </Badge>
              {s.profissionalNome}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-2">
            <div className="grid grid-cols-1 gap-2 text-sm sm:grid-cols-2">
              <Linha label="Data" value={`${diaDaSemana(s.data, true)}, ${formatarData(s.data)}`} />
              <Linha label="Tipo de turno" value={
                <span className="inline-flex items-center gap-2">
                  <span className="h-3 w-3 rounded-full" style={{ backgroundColor: s.tipoTurnoCor }} />
                  {s.tipoTurnoNome}
                </span>
              } />
              <Linha label="Solicitante" value={s.solicitadoPorNome ?? "—"} />
              <Linha label="Criada em" value={s.createdAt ? new Date(s.createdAt).toLocaleString("pt-BR") : "—"} />
            </div>
            {s.motivo && (
              <div className="rounded-md bg-slate-50 p-3 text-sm">
                <span className="font-medium text-slate-700">Motivo:</span> {s.motivo}
              </div>
            )}
            <div className="flex gap-2 pt-2">
              <Button onClick={() => aprovar.mutate({ id: s.id })} disabled={aprovar.isPending}>Aprovar</Button>
              <Button variant="destructive" onClick={() => {
                const obs = prompt("Motivo da rejeição (opcional):") ?? undefined;
                rejeitar.mutate({ id: s.id, observacoes: obs });
              }}>
                Rejeitar
              </Button>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}

function Linha({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-wide text-slate-500">{label}</div>
      <div className="font-medium text-slate-900">{value}</div>
    </div>
  );
}
